module.exports = __webpack_public_path__ + "static/media/logoms.78d0ec41.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logoms.png
// module id = 665
// module chunks = 0